import React from 'react';
import GenericTableFilter from '../../../../../components/common/GenericTableFilter';

const PreApprovalFilters = ({ filterFields, customFilterOptions, customFilterTypes, handleSearch, handleApplyFilters, handleResetFilters }) => {
    return (
        <div className="mb-2">
            <GenericTableFilter 
                filterFields={filterFields} 
                initialFilters={{}} 
                onSearch={handleSearch} 
                onApplyFilters={handleApplyFilters} 
                onResetFilters={handleResetFilters}
                customFilterOptions={customFilterOptions}
                customFilterTypes={customFilterTypes}
            />
        </div>
    );
};

export default PreApprovalFilters;
